import { apiClient } from './api/client';

// Record editing for the /executive dashboard lists.
//
// Executives and Members are canonical `members` rows, so they share one route.
// Prospects are `prospect_applications` rows; that route also keeps the linked
// canonical `members` row consistent on shared identity/contact fields.

export async function updateExecutiveMemberProfile(memberId, payload) {
  return apiClient.patch(`/api/executive/members/${encodeURIComponent(memberId)}/profile`, payload);
}

export async function updateExecutiveProspectRecord(applicationId, payload) {
  return apiClient.patch(`/api/executive/prospects/${encodeURIComponent(applicationId)}`, payload);
}

export async function promoteExecutiveProspect(applicationId) {
  return apiClient.post(`/api/executive/prospects/${encodeURIComponent(applicationId)}/promote`, {});
}
